import { Users, Target, TrendingUp } from "lucide-react";

function StatBlock({ label, value, icon: Icon, testid, color = "#FAFAFA" }) {
  return (
    <div className="flex items-start gap-4">
      <div className="h-10 w-10 grid place-items-center bg-[#18181B] border border-[#27272A]">
        <Icon className="h-5 w-5" style={{ color }} />
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#71717A]">{label}</div>
        <div data-testid={testid} className="font-display text-3xl md:text-4xl tabular" style={{ color }}>
          {value}
        </div>
      </div>
    </div>
  );
}

export default function ProgressBoard({ stats }) {
  const pct = Math.min(100, stats?.percentage || 0);
  return (
    <section
      data-testid="progress-board"
      className="relative z-10 -mt-12 md:-mt-20 max-w-7xl mx-auto px-6 md:px-12"
    >
      <div className="bg-[#0B0B0D]/95 border border-[#27272A] backdrop-blur-xl p-6 md:p-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="text-[10px] uppercase tracking-[0.35em] text-[#A1A1AA]">
              Road to the NATTYS
            </div>
            <div className="font-display text-5xl md:text-6xl mt-2 leading-none">
              <span data-testid="total-raised" className="text-[#00E5FF] tabular">
                ${Number(stats?.total_raised || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
              <span className="text-[#52525B] text-3xl md:text-4xl">
                {" "}/ ${Number(stats?.goal || 10000).toLocaleString()}
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-10">
            <StatBlock
              label="Supporters"
              value={stats?.supporters || 0}
              icon={Users}
              testid="supporters-count"
              color="#FAFAFA"
            />
            <StatBlock
              label="To Goal"
              value={`$${Number(stats?.remaining || 0).toLocaleString()}`}
              icon={Target}
              testid="amount-remaining"
              color="#FACC15"
            />
            <StatBlock
              label="Progress"
              value={`${pct.toFixed(0)}%`}
              icon={TrendingUp}
              testid="percentage-progress"
              color="#FF007F"
            />
          </div>
        </div>

        {/* Progress bar */}
        <div className="mt-8">
          <div className="h-4 bg-[#18181B] border border-[#27272A] overflow-hidden">
            <div
              data-testid="progress-bar"
              className="h-full bg-[#00E5FF] shadow-cyan-glow transition-all duration-1000"
              style={{ width: `${pct}%` }}
            />
          </div>
          <div className="flex justify-between mt-3 text-[10px] uppercase tracking-[0.25em] text-[#71717A]">
            <span>$0</span>
            <span>${Number(stats?.goal || 10000).toLocaleString()} goal</span>
          </div>
        </div>
      </div>
    </section>
  );
}
